import {TipoCFEDTO} from '../TipoCFEDTO';
import {FormaPagoDTO} from '../FormaPagoDTO';
import {ClausulaVentaDTO} from '../ClausulaVentaDTO';
import {ModalidadVentaDTO} from '../ModalidadVentaDTO';
import {ViaTransportacionDTO} from '../ViaTransportacionDTO';

export class DatosInicioIdentificacionDTO
{
  tiposCFEsDTOs: Array<TipoCFEDTO>;
  formasPagosDTOs: Array<FormaPagoDTO>;
  codigoTipoCFESeleccionado: number;
  codigoFormaPagoSeleccionada: number;
  clausulaVentaDTOs: Array<ClausulaVentaDTO>;
  modalidadVentaDTOs: Array<ModalidadVentaDTO>;
  viaTransportacionDTOs: Array<ViaTransportacionDTO>;
}
